import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from '@/App'
import '@/styles/tokens.css'

const container = document.getElementById('root')
if (!container) throw new Error('#root is missing from index.html')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

/**
 * Register the service worker after first paint.
 *
 * Registering during startup competes with the app's own first requests for
 * connections, which is the opposite of what a shell cache is for. Failure is
 * logged and ignored: the worker only makes launches faster and offline
 * honest, so the app must work identically without it.
 */
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error: unknown) => {
      console.warn('Service worker registration failed:', error)
    })
  })
}
